import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Coffee, Dice5, Sparkles, PenTool, Printer, Cable, Heart, Gem, Palette, Calendar, ChevronDown, Flower2 } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { MiniFAQ } from '../components/MiniFAQ';
import { QuoteCard } from '../components/QuoteCard';
import { stories } from '../data/stories';
export function Maekerscafes() {
  const [expandedTheme, setExpandedTheme] = useState<string | null>(null);
  const themes = [{
    name: 'Spelletjesavond',
    icon: <Dice5 size={24} data-id="element-986" />,
    description: 'Een avond vol bordspellen, kaartspellen en gezelligheid. Breng je favoriete spel mee of ontdek iets nieuws. Geschikt voor iedereen, van casual tot strategisch.',
    frequency: 'Elke eerste dinsdag en derde woensdag van de maand'
  }, {
    name: 'Creative Meet Up',
    icon: <Sparkles size={24} data-id="element-987" />,
    description: 'Een open bijeenkomst voor alle creatieve geesten. Deel je werk, krijg feedback en laat je inspireren door andere makers. Elk medium en niveau is welkom.',
    frequency: 'Elke tweede woensdag van de maand'
  }, {
    name: 'Pen(seel) & Papier',
    icon: <PenTool size={24} data-id="element-988" />,
    description: 'Voor iedereen die graag tekent, schildert, kalligrafeert of illustreert. Werk aan je eigen project in een rustige, inspirerende omgeving met gelijkgestemden.',
    frequency: 'Elke eerste woensdag én derde dinsdag van de maand'
  }, {
    name: 'Druk Druk Druk',
    icon: <Printer size={24} data-id="element-989" />,
    description: 'Ontdek de wereld van printmaking: linosnede, zeefdruk, stempels en meer. Basismateriaal is aanwezig, breng gerust je eigen ontwerpen mee.',
    frequency: 'Elke vierde donderdagavond van de maand'
  }, {
    name: 'Draad',
    icon: <Cable size={24} data-id="element-990" />,
    description: 'Voor liefhebbers van macramé, weven en andere draadtechnieken. Leer nieuwe knopen, deel patronen en werk samen aan projecten.',
    frequency: 'Elke tweede en vierde dinsdagavond van de maand'
  }, {
    name: 'Papier',
    icon: <PenTool size={24} data-id="element-991" />,
    description: 'Voor iedereen die graag tekent, schildert, kalligrafeert of illustreert. Werk aan je eigen project in een rustige, inspirerende omgeving met gelijkgestemden.',
    frequency: 'Elke eerste woensdag én derde dinsdag van de maand'
  }, {
    name: 'Juwelen',
    icon: <Gem size={24} data-id="element-992" />,
    description: 'Maak je eigen sieraden: ringen, kettingen, armbanden en meer. Van kralen rijgen tot metaalbewerking, er is voor elk niveau iets te doen.',
    frequency: 'Elke tweede donderdag van de maand'
  }, {
    name: 'Planten',
    icon: <Flower2 size={24} data-id="element-993" />,
    description: 'Voor groene vingers en plantenliefhebbers. Deel tips over verzorging, stekjes en tuinontwerp in een gezellige sfeer.',
    frequency: 'Elke derde donderdagavond van de maand'
  }, {
    name: 'Spelletjes',
    icon: <Dice5 size={24} data-id="element-994" />,
    description: 'Een avond vol bordspellen, kaartspellen en gezelligheid. Breng je favoriete spel mee of ontdek iets nieuws. Geschikt voor iedereen, van casual tot strategisch.',
    frequency: 'Elke eerste dinsdag en derde woensdag van de maand'
  }, {
    name: 'Creativiteit',
    icon: <Sparkles size={24} data-id="element-995" />,
    description: 'Een open bijeenkomst voor alle creatieve geesten. Deel je werk, krijg feedback en laat je inspireren door andere makers. Elk medium en niveau is welkom.',
    frequency: 'Elke tweede woensdag van de maand'
  }, {
    name: 'Keramiek',
    icon: <Heart size={24} data-id="element-996" />,
    description: 'Ontdek de wereld van keramiek: draaien, boetseren, glazuren en meer. Werk aan je eigen project of experimenteer met nieuwe technieken.',
    frequency: 'Elke vierde donderdagavond van de maand'
  }];
  const toggleTheme = (name: string) => {
    setExpandedTheme(expandedTheme === name ? null : name);
  };
  return <div data-id="element-997">
      {/* Hero section */}
      <section className="relative bg-gray-100 border-b border-gray-300" data-id="element-998">
        <div className="relative h-[400px] md:h-[480px] overflow-hidden" data-id="element-999">
          <div className="absolute inset-0 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100" data-id="element-1000">
            <span className="text-gray-400 text-lg" data-id="element-1001">
              Maekerscafé sfeerbeeld
            </span>
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 pointer-events-none" data-id="element-1002">
            <div className="bg-white/90 border border-gray-200 rounded-lg px-8 py-8 md:px-12 md:py-10 text-center pointer-events-auto" data-id="element-1003">
              <h1 className="text-4xl md:text-5xl font-bold" data-id="element-1004">Maekerscafés</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4" data-id="element-1005">
        {/* What to expect section */}
        <section className="py-16" data-id="element-1006">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" data-id="element-1007">
            Wat kun je verwachten?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed text-center max-w-3xl mx-auto mb-10" data-id="element-1008">
            Maekerscafés zijn informele bijeenkomsten waar makers met dezelfde
            interesse samenkomen om te werken, kennis te delen en te netwerken.
            Of je nu een ervaren vakman bent of net begint, iedereen is welkom.
            Breng je eigen project mee of kom gewoon langs voor inspiratie en
            gezelligheid.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-1009">
            <Card variant="outlined" data-id="element-1010">
              <CardContent className="text-center" data-id="element-1011">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1012">
                  <Coffee size={24} className="text-gray-400" data-id="element-1013" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1014">Informele sfeer</h3>
                <p className="text-sm text-gray-600" data-id="element-1015">
                  Geen vaste agenda, gewoon werken aan je eigen projecten in
                  gezelschap van gelijkgestemden.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1016">
              <CardContent className="text-center" data-id="element-1017">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1018">
                  <Coffee size={24} className="text-gray-400" data-id="element-1019" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1020">Kennisdeling</h3>
                <p className="text-sm text-gray-600" data-id="element-1021">
                  Leer van elkaar, deel tips en tricks, en krijg feedback op je
                  werk van ervaren makers.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1022">
              <CardContent className="text-center" data-id="element-1023">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1024">
                  <Coffee size={24} className="text-gray-400" data-id="element-1025" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1026">Gratis toegang</h3>
                <p className="text-sm text-gray-600" data-id="element-1027">
                  Deelname is gratis, je betaalt een drankje aan de bar.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Themes section */}
        <section className="mb-16" data-id="element-1028">
          <div className="max-w-5xl mx-auto" data-id="element-1029">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-1030">
              Onze Maekerscafés
            </h2>
            {(() => {
            const rowSize = 4;
            const rows: (typeof themes)[] = [];
            for (let i = 0; i < themes.length; i += rowSize) {
              rows.push(themes.slice(i, i + rowSize));
            }
            return rows.map((row, rowIndex) => {
              const expandedInRow = expandedTheme ? row.find(t => t.name === expandedTheme) : null;
              return <div key={rowIndex} data-id="element-1031">
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4" data-id="element-1032">
                      {row.map(theme => {
                    const isExpanded = expandedTheme === theme.name;
                    return <button key={theme.name} onClick={() => toggleTheme(theme.name)} className={`flex flex-col items-center text-center border rounded-lg p-5 bg-white transition-colors duration-150 cursor-pointer focus:outline-none focus:ring-2 focus:ring-gray-300 ${isExpanded ? 'border-gray-400 bg-gray-50' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-1033">
                            <div className={`mb-3 p-3 rounded-full transition-colors duration-150 ${isExpanded ? 'bg-gray-200 text-gray-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-1034">
                              {theme.icon}
                            </div>
                            <span className="text-sm font-medium mb-1" data-id="element-1035">
                              {theme.name}
                            </span>
                            <ChevronDown size={14} className={`text-gray-400 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-1036" />
                          </button>;
                  })}
                    </div>

                    {expandedInRow && <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-1037">
                        <div className="flex flex-col md:flex-row" data-id="element-1038">
                          <div className="md:w-1/3 border-b md:border-b-0 md:border-r border-dashed border-gray-200 h-48 md:h-auto flex items-center justify-center bg-gray-100" data-id="element-1039">
                            <span className="text-gray-400 text-sm" data-id="element-1040">
                              {expandedInRow.name} sfeerbeeld
                            </span>
                          </div>
                          <div className="p-6 md:w-2/3" data-id="element-1041">
                            <h3 className="font-bold text-lg mb-2" data-id="element-1042">
                              {expandedInRow.name}
                            </h3>
                            <p className="text-sm text-gray-600 mb-4" data-id="element-1043">
                              {expandedInRow.description}
                            </p>
                            <div className="text-sm" data-id="element-1044">
                              <span className="font-medium text-gray-900" data-id="element-1045">
                                Wanneer:
                              </span>{' '}
                              <span className="text-gray-600" data-id="element-1046">
                                {expandedInRow.frequency}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>}
                  </div>;
            });
          })()}
          </div>
        </section>

        {/* CTA section */}
        <section className="mb-16" data-id="element-1047">
          <div className="max-w-3xl mx-auto text-center bg-gray-50 p-8 md:p-12 rounded-lg border border-gray-200" data-id="element-1048">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1049">
              Bekijk de kalender
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1050">
              Ontdek wanneer de volgende maekerscafés plaatsvinden en schrijf je
              in voor de bijeenkomsten die je interesseren.
            </p>
            <Link to="/workshops?type=maekerscafe" data-id="element-1051">
              <Button variant="primary" size="large" rightIcon={<ArrowRight size={18} data-id="element-1053" />} data-id="element-1052">
                Naar de kalender
              </Button>
            </Link>
          </div>
        </section>

        {/* Community story */}
        <section className="mb-16" data-id="element-1054">
          <div className="max-w-3xl mx-auto" data-id="element-1055">
            <h2 className="text-xl font-bold mb-4" data-id="element-1056">
              Verhalen uit de community
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1057">
              {stories.filter(s => s.category === 'maekerscafe').slice(0, 2).map((story, i) => <QuoteCard key={i} story={story} data-id="element-1058" />)}
            </div>
          </div>
        </section>

        {/* Info section */}
        <section className="mb-8" data-id="element-1059">
          <div className="max-w-3xl mx-auto" data-id="element-1060">
            <Card variant="outlined" data-id="element-1061">
              <CardContent data-id="element-1062">
                <h3 className="font-bold mb-3" data-id="element-1063">Praktische informatie</h3>
                <div className="space-y-3 text-sm text-gray-600" data-id="element-1064">
                  <div data-id="element-1065">
                    <span className="font-medium text-gray-900" data-id="element-1066">Kosten:</span>{' '}
                    Deelname is gratis, je betaalt een drankje aan de bar.
                  </div>
                  <div data-id="element-1067">
                    <span className="font-medium text-gray-900" data-id="element-1068">Duur:</span>{' '}
                    Meestal 2-3 uur, maar je mag komen en gaan wanneer je wilt.
                  </div>
                  <div data-id="element-1069">
                    <span className="font-medium text-gray-900" data-id="element-1070">
                      Wat meenemen:
                    </span>{' '}
                    Je eigen project en materialen. Basis gereedschap is
                    aanwezig.
                  </div>
                  <div data-id="element-1071">
                    <span className="font-medium text-gray-900" data-id="element-1072">
                      Aanmelden:
                    </span>{' '}
                    Niet verplicht, maar wel handig zodat we weten hoeveel
                    mensen er komen.
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* FAQ section */}
        <div className="max-w-3xl mx-auto mb-8" data-id="element-1073">
          <MiniFAQ category="Maekerscafés" data-id="element-1074" />
        </div>
      </div>
    </div>;
}